
export const PartnerLogos = () => {
  return (
    <div className="text-center mt-20">
      <p className="text-brutal-charcoal text-sm uppercase tracking-wider mb-8 font-mono">
        Works with your favorite spa software
      </p>
      <div className="brutal-card" role="list" aria-label="Supported spa software platforms">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 items-center justify-center">
          <div className="flex items-center justify-center h-16">
            <img 
              src="/lovable-uploads/914a0018-31ba-4882-8d5a-f97c77921a0a.png" 
              alt="Vagaro spa management software" 
              className="h-8 w-auto object-contain" 
            />
          </div>
          <div className="flex items-center justify-center h-16">
            <img 
              src="/lovable-uploads/4e8f1b0e-d148-4ce6-b43c-79631a6ad14f.png" 
              alt="Fresha spa booking system" 
              className="h-8 w-auto object-contain" 
            />
          </div>
          <div className="flex items-center justify-center h-16">
            <img 
              src="/lovable-uploads/e7d663d7-1652-4978-8d2e-fbd5afac95b5.png" 
              alt="Mangomint spa business software" 
              className="h-8 w-auto object-contain" 
            />
          </div>
          <div className="flex items-center justify-center h-16">
            <img 
              src="/lovable-uploads/53c24c90-400a-44f6-a9bc-2205d1721e88.png" 
              alt="MINDBODY spa management platform" 
              className="h-8 w-auto object-contain" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};
